<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';
import ViewsConfiguratorV2 from '@/components/view/v2/ViewsConfiguratorV2.vue';

export default {
  name: 'ViewsConfiguratorV2Field',
  components: { ViewsConfiguratorV2 },
  mixins: [Input, Editable],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    realm: {
      type: String,
      default: '',
    },
    subscription: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sections: [],
    };
  },
  watch: {
    value: {
      deep: false,
      handler(val) {
        if (val !== this.sections) {
          this.sections = val || [];
        }
      },
    },
  },
  created() {
    this.sections = this.value || [];
  },
  methods: {
    onChildInput(val) {
      this.sections = val || [];
      // For v-model on parent
      this.$emit('input', this.sections);
      // Notify va-form via Input mixin so it serializes `source="sections"`
      this.update(this.sections);
    },
  },
};
</script>

<template>
  <div>
    <ViewsConfiguratorV2
      :value="sections"
      @input="onChildInput"
      :realm="realm"
      :subscription="subscription"
    />
  </div>
</template>
